export const SUCCESS_MESSAGES = {
  voucherPaymentWidthdraw: 'voucherPaymentWidthdraw',
  codeRegistrationSuccess: 'codeRegistrationSuccess',
};
